import { useRef, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api.js'
import { VERSION_BUNDLE, firmaVersion } from '../lib/version-cliente.js'

/**
 * Aviso de versión nueva de la consola.
 *
 * Referencia: la versión horneada en el bundle (VERSION_BUNDLE) — describe el código que corre,
 * sobreviva o no el componente a un desmontaje. Sin ella (dev server), la primera respuesta.
 *
 * El sondeo tiene su PROPIA consulta ('version-sondeo'), separada de la del pie de página:
 * compartían clave y el pie la observaba con staleTime infinito — dos observadores con
 * políticas opuestas sobre la misma caché es exactamente el tipo de interacción fina donde un
 * refetch puede no ocurrir cuando se espera, y este aviso ya falló dos veces en silencio.
 * Separar las consultas cuesta una petición trivial y elimina la clase entera de problema.
 */
export function AvisoVersion() {
  const base = useRef(VERSION_BUNDLE?.version ? firmaVersion(VERSION_BUNDLE) : null)
  const [descartada, setDescartada] = useState(null)

  const q = useQuery({
    queryKey: ['version-sondeo'],
    queryFn: api.version,
    refetchInterval: 45_000,
    refetchIntervalInBackground: false,
    // 'always': al volver el foco se consulta SIEMPRE, sin negociar frescura — es el momento
    // típico de «acabo de desplegar y vuelvo a la pestaña».
    refetchOnWindowFocus: 'always',
    staleTime: 0,
  })

  if (!q.data) return null
  const actual = firmaVersion(q.data)
  if (base.current == null) base.current = actual

  // Descartar silencia ESA versión; si después llega otra más, el aviso vuelve.
  if (actual === base.current || actual === descartada) return null

  return (
    <div className="aviso-version" role="status">
      <span>
        Hay una versión nueva de la consola (<strong>v{q.data.version}</strong>
        {VERSION_BUNDLE?.version ? <> · tienes cargada la v{VERSION_BUNDLE.version}</> : null}).
      </span>
      <button className="btn primary sm" onClick={() => window.location.reload()}>
        Actualizar
      </button>
      <button className="aviso-cerrar" aria-label="Descartar" title="Seguir con la versión cargada"
              onClick={() => setDescartada(actual)}>
        ×
      </button>
    </div>
  )
}
